import gql from 'graphql-tag';

import { FEED_QUESTION_DETAILS_FRAGMENT } from '../feed/feedQuestionDetails';
import { BOARD_OVERVIEW_FRAGMENT } from './boardOverview';

export const FEEDBOARD_RESPONSE_FRAGMENT = gql`
  fragment feedBoardResponse on Board {
    ...boardOverview
    questions(filterPublishStatus: $filterPublishStatus, labelIds: $labelIds) {
      items {
        ...feedQuestionDetails
      }
      nextCursor
    }
    faqCount(filterPublishStatus: $filterPublishStatus, labelIds: $labelIds)
    deleted
  }

  ${BOARD_OVERVIEW_FRAGMENT}
  ${FEED_QUESTION_DETAILS_FRAGMENT}
`;
